import { render, staticRenderFns } from "./SevereSymptomsAssessment.vue?vue&type=template&id=0fe3129a&scoped=true&"
import script from "./SevereSymptomsAssessment.vue?vue&type=script&lang=js&"
export * from "./SevereSymptomsAssessment.vue?vue&type=script&lang=js&"
import style0 from "./SevereSymptomsAssessment.vue?vue&type=style&index=0&id=0fe3129a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe3129a",
  null
  
)

export default component.exports